import u from "./ghl-ui.es1476.js";
import v from "./ghl-ui.es1477.js";
import d from "./ghl-ui.es1478.js";
var g = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function b(m, f, p) {
  var t = String(f), o = p || {}, n = t.match(g);
  if (n) {
    var c = d(m, o);
    t = n.reduce(function(a, r) {
      if (r[0] === "'")
        return a;
      var e = a.indexOf(r), s = a[e - 1] === "'", i = a.replace(
        r,
        "'" + v[r[0]](c, r, null, o) + "'"
      );
      return s ? i.substring(0, e - 1) + i.substring(e + 1) : i;
    }, t);
  }
  return u(m, t, o);
}
export {
  b as default
};
